<template>
  <div class="wrapper">
    <section
      v-if="$route.name == 'jobs-info' || $route.name == 'jobs-info-ngo'"
      class="wf100 subheader"
      style="margin-bottom: 10px; background: #048042"
    >
      <div class="container">
        <h2>تفاصيل العمل</h2>
        <ul>
          <li><router-link to="/" href="#">الرئيسية</router-link></li>
          <li v-if="this.$route.params.id">المنظمة</li>
          <li>فرص العمل</li>
          <li>تفاصيل فرص العمل</li>
        </ul>
      </div>
    </section>
    <section
      v-else
      class="wf100 subheader"
      style="margin-bottom: 10px; background: #a21caf"
    >
      <div class="container">
        <h2>تفاصيل التطوع</h2>
        <ul>
          <li><router-link to="/" href="#">الرئيسية</router-link></li>
          <li v-if="this.$route.params.id">المنظمة</li>
          <li>فرص التطوع</li>
          <li>تفاصيل فرص التطوع</li>
        </ul>
      </div>
    </section>
    <div class="container general-activities">
      <div class="events-wrapper events-listing">
        <div v-if="loading" class="container">
          <basc-card v-for="n in 4" :key="n">
            <b-skeleton animation="fade" height="22px" width="25%"></b-skeleton>
            <div style="margin: 15px 15px">
              <b-skeleton animation="fade" width="100%"></b-skeleton>
              <b-skeleton animation="fade" width="100%"></b-skeleton>
            </div>
          </basc-card>
        </div>
        <div v-else>
          <basc-card>
            <h4
              class="title"
              :style="{
                color:
                  $route.name == 'jobs-info' || $router.name == 'jobs-info-ngo'
                    ? '#048042'
                    : '#a21caf',
              }"
              style="margin-bottom: 15px"
            >
              <feather-icon icon="UserIcon" size="23" class="mx-25" />
              {{ jobInfo.name }}
            </h4>
            <table class="mt-2 w-100 table table-bordered">
              <tbody>
                <tr>
                  <td><feather-icon icon="UserIcon" class="mr-1" />المنظمة</td>
                  <td>{{ jobInfo.ngo_name }}</td>
                </tr>
                <tr>
                  <td>
                    <feather-icon icon="HashIcon" class="mr-1" />رقم الشاغر
                  </td>
                  <td>{{ jobInfo.code }}</td>
                </tr>
                <tr>
                  <td>
                    <feather-icon icon="SquareIcon" class="mr-1" />مجال العمل
                  </td>
                  <td>{{ jobInfo.positionType.name_ar }}</td>
                </tr>
                <tr>
                  <td><feather-icon icon="MapPinIcon" class="mr-1" />المكان</td>
                  <td>{{ jobInfo.governorate.name_ar }}</td>
                </tr>
                <tr>
                  <td>
                    <feather-icon icon="CalendarIcon" class="mr-1" />تاريخ
                    الإعلان
                  </td>
                  <td>
                    {{ $moment(jobInfo.starting_date).format("DD-MM-YYYY") }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <feather-icon icon="CalendarIcon" class="mr-1" />تاريخ إغلاق
                    الشاغر
                  </td>
                  <td>
                    {{ $moment(jobInfo.closing_date).format("DD-MM-YYYY") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </basc-card>
          <basc-card>
            <h4
              class="title"
              :style="{
                color:
                  $route.name == 'jobs-info' || $router.name == 'jobs-info-ngo'
                    ? '#048042'
                    : '#a21caf',
              }"
              style="margin-bottom: 15px"
            >
              <feather-icon icon="FileTextIcon" size="23" class="mx-25" />
              الغرض من الوظيفة
            </h4>
            <div
              class="px-1"
              style="line-height: 2; text-align: justify"
              v-html="jobInfo.opportunity_objectives_ar"
            ></div>
          </basc-card>
          <basc-card>
            <h4
              class="title"
              :style="{
                color:
                  $route.name == 'jobs-info' || $router.name == 'jobs-info-ngo'
                    ? '#048042'
                    : '#a21caf',
              }"
              style="margin-bottom: 15px"
            >
              <feather-icon icon="AwardIcon" size="23" class="mx-25" />
              المؤهل العلمي
            </h4>
            <div class="text_edit" v-html="jobInfo.certificate_ar"></div>
          </basc-card>
          <basc-card>
            <h4
              class="title"
              :style="{
                color:
                  $route.name == 'jobs-info' || $router.name == 'jobs-info-ngo'
                    ? '#048042'
                    : '#a21caf',
              }"
              style="margin-bottom: 15px"
            >
              <feather-icon icon="BriefcaseIcon" size="23" class="mx-25" />
              المهارات
            </h4>
            <div class="d-flex flex-wrap">
              <div style="font-size: 15px">
                <div class="text_edit" v-html="jobInfo.skill_ar"></div>
              </div>
            </div>
          </basc-card>

          <basc-card>
            <h4
              class="title"
              style="margin-bottom: 15px"
              :style="{
                color:
                  $route.name == 'jobs-info' || $router.name == 'jobs-info-ngo'
                    ? '#048042'
                    : '#a21caf',
              }"
            >
              <feather-icon icon="FileTextIcon" size="23" class="mx-25" />
              الخبرات
            </h4>
            <div class="d-flex flex-wrap">
              <div style="font-size: 15px">
                <div class="text_edit" v-html="jobInfo.experience_ar"></div>
              </div>
            </div>
          </basc-card>
          <basc-card>
            <h4
              class="title"
              style="margin-bottom: 15px"
              :style="{
                color:
                  $route.name == 'jobs-info' || $router.name == 'jobs-info-ngo'
                    ? '#048042'
                    : '#a21caf',
              }"
            >
              <feather-icon icon="EditIcon" size="23" class="mx-25" />
              طبيعة الإلتزام
            </h4>
            <div style="font-size: 15px">
              {{ jobInfo.employment_type_ar }}
            </div>
          </basc-card>
          <basc-card>
            <h4
              class="title"
              style="margin-bottom: 15px"
              :style="{
                color:
                  $route.name == 'jobs-info' || $router.name == 'jobs-info-ngo'
                    ? '#048042'
                    : '#a21caf',
              }"
            >
              <feather-icon icon="Share2Icon" size="23" class="mx-25" /> معلومات
              التواصل
            </h4>
            <div>
              <ul>
                <li v-for="(item, i) in jobInfo.contacts" :key="i">
                  <img
                    :src="
                      require(`@/assets/contacts/ngo_${item.type.icon}.png`)
                    "
                    width="18"
                    height="18"
                    class="mr-1"
                  />
                  {{ item.value }}
                </li>
              </ul>
            </div>
          </basc-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BascCard from "../../components/BascCard.vue";
import { mapGetters } from "vuex";
import {
  BListGroup,
  BListGroupItem,
  BButton,
  BAvatar,
  BSkeleton,
} from "bootstrap-vue";

export default {
  components: {
    BListGroup,
    BListGroupItem,
    BButton,
    BascCard,
    BAvatar,
    BSkeleton,
  },
  computed: {
    ...mapGetters("NgoHome/jobInfo", ["jobInfo", "loading"]),
  },
  created() {
    this.$store.dispatch("NgoHome/jobInfo/getJobInfo", {
      id: this.$route.params.id_info,
    });
  },
};
</script>

<style lang="scss">
.title {
  font-family: Almarai, sans-serif;
  font-weight: 400;
  letter-spacing: 0.00735em;
  /* line-height: 2.5rem; */
  color: #82868b;
  /* padding-top: 10px; */
}

.itemSkills {
  padding: 5px;
  padding-left: 20px;
  padding-right: 20px;
  border: 1px solid #82868b;
  border-radius: 3px;
  margin: 10px;
}
.table_job {
  tr {
    td {
      border: 1px solid #ccc;
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }
}
.text_edit {
  ul {
    li {
      list-style-type: disc;
    }
  }
}
.volunteer_color {
  color: #a21caf;
}
</style>
